/**
 * @param {string} input
 * @return {string}
 */
export const stripTags = function(input) {
    const tmp = document.createElement('div');
    tmp.innerHTML = input;
    return tmp.textContent || tmp.innerText || '';
}